const API = import.meta.env.VITE_API_URL || 'http://localhost:5177/api'

export const TENANT_ID = 1

export class ApiError extends Error {
  status: number
  constructor(message: string, status: number) {
    super(message)
    this.name = 'ApiError'
    this.status = status
  }
}

async function request<T>(path: string, init?: RequestInit): Promise<T> {
  const token = localStorage.getItem('logistica:token')
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
  }
  if (token) headers['Authorization'] = `Bearer ${token}`
  if (init?.headers) Object.assign(headers, init.headers as Record<string, string>)

  const res = await fetch(`${API}${path}`, {
    ...init,
    headers,
  })
  if (!res.ok) {
    const text = await res.text()
    throw new ApiError(text || `Error ${res.status}`, res.status)
  }
  const contentType = res.headers.get('content-type')
  if (contentType?.includes('application/json')) {
    return res.json() as Promise<T>
  }
  return undefined as T
}

export const api = {
  get: <T>(path: string, init?: RequestInit) => request<T>(path, init),
  post: <T>(path: string, data: unknown, init?: RequestInit) =>
    request<T>(path, { method: 'POST', body: JSON.stringify(data), ...init }),
  put: <T>(path: string, data: unknown, init?: RequestInit) =>
    request<T>(path, { method: 'PUT', body: JSON.stringify(data), ...init }),
  del: <T>(path: string, init?: RequestInit) => request<T>(path, { method: 'DELETE', ...init }),
}
